import { ComponentProps } from "react";
import { Dialog, ScrollView, styled, Image as TGImage } from "tamagui";

import { Accordion } from "../../ui/accordion";
import { Card } from "../../ui/card";
import { RenderMd } from "../../ui/custom-md";
import { Tag } from "../../ui/tag";

type DialogContainerProps = ComponentProps<typeof Dialog.Content>;

const DialogContainer: React.FC<DialogContainerProps> = ({
  children,
  ...rest
}) => {
  return (
    <Dialog.Content
      borderWidth={0}
      backgroundColor={"transparent"}
      padding={0}
      zIndex={9999}
      {...rest}
      unstyled
    >
      <Card
        paddingHorizontal={"$4"}
        paddingVertical={"$5"}
        gap={"$5"}
        backgroundColor={"$warm-snow-500"}
        alignItems="center"
        maxWidth={636}
        $sm={{
          paddingHorizontal: "$2",
          paddingVertical: "$3",
          gap: "$3",
        }}
      >
        {children}
      </Card>
    </Dialog.Content>
  );
};

type DialogContentProps = ComponentProps<typeof Card>;

const DialogContent: React.FC<DialogContentProps> = (props) => {
  return (
    <Card
      gap={"$5"}
      variant="borderless"
      backgroundColor={"white"}
      padding={"$4"}
      $sm={{
        padding: "$2",
      }}
      {...props}
    >
      <ScrollView $sm={{ maxHeight: 200 }} maxHeight={400}>
        {props.children}
      </ScrollView>
    </Card>
  );
};

type ImageProps = ComponentProps<typeof TGImage> & { path?: string };

const Image: React.FC<ImageProps> = ({ path, source, ...props }) => {
  return (
    <TGImage
      style={{
        maxWidth: 140,
        maxHeight: 140,
      }}
      $sm={{
        maxWidth: 100,
        maxHeight: 100,
      }}
      source={path ? { width: 120, height: 120, uri: path } : source}
      {...props}
    />
  );
};

const Title = styled(Dialog.Title, {
  name: "RecommendationDialogTitle",
  color: "$grey-950",
  fontFamily: "$subtitle",
  variants: {
    font: {
      lg: {
        fontWeight: "$4",
        fontSize: "$4",
        lineHeight: "$4",
      },
    },
  } as const,
  defaultVariants: {
    font: "lg",
  },
});

export const RecommendationDialogItems = {
  Container: DialogContainer,
  Image,
  Tag,
  Content: DialogContent,
  Accordion,
  RenderMd,
  Title,
};
